import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import { useLocation, useNavigate } from "react-router-dom";
import { AddButton } from "../../utils/commonComponent/Custom/Button";
import { submitSiteDelete } from "./../../utils/commonComponent/delete";
import {
  fetchByTable,
  fetchQuery,
} from "./../../utils/commonComponent/fetched";
import ListSearchSection from "../../utils/commonComponent/Custom/ListSearchSection";
import ListView from "../../utils/commonComponent/Custom/listView";
import { getPermissions } from "../rbac/hasAccess";
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AppConfirmBox from "../../utils/commonComponent/appConfirmBox";
import axiosWithToken from "../../utils/commonComponent/axiosTokenConfig";
import { BASE_URL } from "../../global";
import { SearchToggleButton } from "../../utils/commonComponent/Custom/Button";
import { Autocomplete, Checkbox, TextField } from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { SUBTYPE_OPTIONS } from "./subtypes";
import { departmentOptions } from "../employeeMaster/employeeConstants";


const headers = [
  "id",
  "requirementType",
  "jobNumber",
  "requesterName",
  "department",
  "siteName",
  "approveStatus",
  "disbursedStatus",
  "rejectionReason",
  "totalAmount",
  "date",
];

export const requirementTypeOptions = [
  { id: 1, name: "Advance" },
  { id: 2, name: "Reimbursement" },
  { id: 3, name: "10 Days Advance" },
];

const fields = [
  { value: "requirementType", label: "Requirement Type" },
  { value: "jobNumber", label: "Job Number" },
  { value: "requesterName", label: "Requester Name" },
  // { value: "approveStatus", label: "Approve Status" },
  // { value: "disbursedStatus", label: "Disbursed Status" },
];

const STATUS_OPTIONS = [
  { label: "Approved", value: "Approved" },
  { label: "Rejected", value: "Rejected" },
  { label: "Pending", value: "Pending" },
];

const modalHeaders = [
  "l1ApproveStatus",
  "hodApproveStatus",
  "h1ApproveStatus",
  "h2ApproveStatus",
  "rejectionReason",
];

const RequirementList = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const permissions = getPermissions(props.moduleId);
  const handleEdit = (row) => navigate(`/editRequirement/${row.id}`);
  const handlePrint = (row) => navigate(`/requirementView/${row.id}`);

  const handleDelete = (row) => submitSiteDelete("requirements", row.id);

  const [disciplineList, setRequirementList] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [searchBy, setSearchBy] = React.useState(
    sessionStorage.getItem("searchBy") || "jobNumber",
  );
  const [searchKey, setSearchKey] = React.useState(
    sessionStorage.getItem("searchKey") || "",
  );
  const [searched, setSearched] = React.useState(
    sessionStorage.getItem("searched") === "true" || false,
  );
  // Pagination
  const [currentPage, setCurrentPage] = useState(() =>
    Number(sessionStorage.getItem("ListPageCount") || 0),
  );
  const [rowsPerPage, setRowsPerPage] = useState(() =>
    Number(sessionStorage.getItem("ListRowsPerPage") || 30),
  );
  const _employeeId = Number(localStorage.getItem("employeeId"));
  const _userType = Number(localStorage.getItem("type"));
  const [openConfirm, setOpenConfirm] = React.useState(false);
  const [dialogProps, setDialogProps] = React.useState({});
  const [remark, setRemark] = React.useState("");
  const [amount, setAmount] = React.useState("");

  const [open, setOpen] = React.useState(false);
  const [selectedRow, setSelectedRow] = React.useState(null);
  const [fromDate, setFromDate] = React.useState("");
  const [toDate, setToDate] = React.useState("");
  const [inputStates, setInputStates] = React.useState({ approveStatus: [] });
  const [employeesData, setEmployeesData] = useState([]);
  const [jobData, setJobData] = useState([]);

  const updateInputObject = (key, value) => {
    setInputStates((prevInputStates) => ({
      ...prevInputStates,
      [key]: value,
    }));
    setSearched(false);
  };

  const handleModal = (row) => {
    setSelectedRow(row);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedRow(null);
  };

  const handlePaginationChange = (page, rows) => {
    setCurrentPage(page);
    setRowsPerPage(rows);
    // fetch new data from backend here
  };

  const formatDate = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const getWhereClause = () => {
    const colMap = {
      jobNumber: "jr.jobNumber",
      requestedName: "e.name",
    };

    const colName = colMap[searchBy];
    const key = searchKey.trim();

    let whereConditions = ["r.status = 1"];

    // Search filter
    if (colName && key) {
      whereConditions.push(`${colName} LIKE '%${key}%'`);
    }

    // Date filter from inputStates
    const from = inputStates?.fromDate;
    const to = inputStates?.toDate;
    if (from && to) {
      whereConditions.push(
        `r.date BETWEEN '${formatDate(from)} 00:00:00' AND '${formatDate(to)} 23:59:59'`,
      );
    }

    // Employee filter from inputStates
    if (inputStates?.employeeIds?.length > 0) {
      whereConditions.push(
        `r.requesterId IN (${inputStates.employeeIds.join(",")})`,
      );
    }

    // 📋 Requirement Type filter from inputStates
    if (inputStates?.requirementTypes?.length > 0) {
      const requirementTypeList = inputStates.requirementTypes
        .map((type) => `'${type}'`)
        .join(",");
      whereConditions.push(`r.requirmentType IN (${requirementTypeList})`);
    }

    // Sub Types filter from inputStates
    if (inputStates?.subTypes?.length > 0) {
      const subTypeValues = inputStates.subTypes.map((s) => `'${s}'`).join(",");
      whereConditions.push(
        `r.id IN (SELECT requirementId FROM requirementPrices WHERE status = 1 AND subTypes IN (${subTypeValues}))`,
      );
    }

    // Disbursement Status filter from inputStates
    if (inputStates?.disbursementStatus?.length > 0) {
      const statusValues = inputStates.disbursementStatus
        .map((s) => (typeof s === "object" ? s.value : s))
        .join(",");
      whereConditions.push(`r.disbursedStatus IN (${statusValues})`);
    }

    // Job filter from inputStates
    if (inputStates?.selectedJobIds?.length > 0) {
      whereConditions.push(
        `r.jobId IN (${inputStates?.selectedJobIds.join(",")})`,
      );
    }

    // Permission logic
    const hasFullAccess = permissions.l1 || permissions.h1 || permissions.h2;
    const hasHod = permissions.hod;
    const hasL2 = permissions.l2;

    // ── Approve Status filter (only for hasFullAccess) ──
    if (inputStates?.approveStatus?.length > 0) {
      const approveConditions = inputStates.approveStatus
        .map((s) => {
          const val = typeof s === "object" ? s.value : s;
          if (val === "Approved") {
            return `(r.l1Status != 2 AND r.hodStatus != 2 AND r.h1Status != 2 AND r.h2Status = 1)`;
          } else if (val === "Rejected") {
            return `(r.l1Status = 2 OR r.hodStatus = 2 OR r.h1Status = 2 OR r.h2Status = 2)`;
          } else {
            return `(r.l1Status != 2 AND r.hodStatus != 2 AND r.h1Status != 2 AND r.h2Status != 2 AND r.h2Status != 1)`;
          }
        })
        .join(" OR ");
      whereConditions.push(`(${approveConditions})`);
    } else {
      const pendingConditions = [];

      if (permissions.l1) {
        pendingConditions.push(`(r.l1Status != 2 AND r.l1Status != 1  AND r.h2Status != 1 AND r.h2Status != 2 )`);
      }
      if (permissions.hod) {
        pendingConditions.push(
          `(r.l1Status = 1 AND r.hodStatus != 1 AND r.hodStatus != 2  AND r.h2Status != 1 AND r.h2Status != 2)`
        );
      }
      if (permissions.h1) {
        pendingConditions.push(
          `(r.l1Status = 1  AND r.h1Status != 2 AND r.h1Status != 1  AND r.h2Status != 1 AND r.h2Status != 2 and r.hodStatus!=2 )`
        );
      }
      if (permissions.h2) {
        pendingConditions.push(
          `(r.l1Status = 1   AND r.h2Status != 1 AND r.h2Status != 2 and r.hodStatus!=2)`
        );
      }

      if (pendingConditions.length > 0) {
        whereConditions.push(`(${pendingConditions.join(" OR ")})`);
      }
    }

    if (hasFullAccess || (hasL2 && inputStates?.approveStatus?.length != 0)) {
      // Highest privilege — no restriction
    } else if (hasHod) {
      // HOD or HOD+L2 → scoped to their projects
      whereConditions.push(`jr.projectHodId = ${_employeeId}`);
    } else if (hasL2 && inputStates?.approveStatus?.length == 0) {
      // L2 only → see h2 approved records
      whereConditions.push("r.h2Status = 1");
    } else {
      // No special role → own requests only
      whereConditions.push(`r.requesterId = ${_employeeId}`);
    }

    return `WHERE ${whereConditions.join(" AND ")}`;
  };

  const getDataQuery = () => {
    const whereClause = getWhereClause();

    const paginationSettings =
      rowsPerPage !== -1
        ? `LIMIT ${rowsPerPage} OFFSET ${rowsPerPage * Number(currentPage)}`
        : "";

    return `SELECT r.*, r.requirmentType as requirementType,CASE WHEN r.disbursedStatus=1 THEN 'Disbursed' WHEN r.disbursedStatus=2 THEN 'Partially Disbursed' ELSE 'Pending' END AS disbursedStatus, CASE WHEN r.l1Status=1 THEN 'Approved' WHEN r.l1Status=2 THEN 'Rejected' WHEN r.hodStatus IN (1,2) THEN 'Overridden by HOD' WHEN r.h1Status IN (1,2) THEN 'Overridden by H1' WHEN r.h2Status IN (1,2) THEN 'Overridden by H2' ELSE 'Pending' END AS l1ApproveStatus, CASE WHEN r.hodStatus=1 THEN 'Approved' WHEN r.hodStatus=2 THEN 'Rejected' WHEN r.h1Status IN (1,2) THEN 'Overridden by H1' WHEN r.h2Status IN (1,2) THEN 'Overridden by H2' ELSE 'Pending' END AS hodApproveStatus, CASE WHEN r.h1Status=1 THEN 'Approved' WHEN r.h1Status=2 THEN 'Rejected' WHEN r.h2Status IN (1,2) THEN 'Overridden by H2' ELSE 'Pending' END AS h1ApproveStatus, CASE WHEN r.h2Status=1 THEN 'Approved' WHEN r.h2Status=2 THEN 'Rejected' ELSE 'Pending' END AS h2ApproveStatus, CASE WHEN r.l1Status=2 OR r.hodStatus=2 OR r.h1Status=2 OR r.h2Status=2 THEN 'Rejected' WHEN r.h2Status=1 THEN 'Approved' WHEN r.h1Status IN (1,2) THEN 'Pending at H2' WHEN r.hodStatus IN (1,2) THEN 'Pending at H1' WHEN r.l1Status IN (1,2) THEN 'Pending at HOD' ELSE 'Pending at L1' END AS approveStatus, jr.jobNumber AS jobNumber, jr.projectHodId,  jr.siteName, e.name AS requesterName, CONCAT(e_l1.name,'(',e_l1.employeesCode,')') AS l1Name, CONCAT(e_hod.name,'(',e_hod.employeesCode,')') AS hodName, CONCAT(e_h1.name,'(',e_h1.employeesCode,')') AS h1Name, CONCAT(e_h2.name,'(',e_h2.employeesCode,')') AS h2Name FROM requirements r LEFT JOIN jobRegister jr ON r.jobId = jr.id LEFT JOIN employees e ON r.requesterId = e.id LEFT JOIN employees e_l1 ON r.l1Id = e_l1.id LEFT JOIN employees e_hod ON r.hodId = e_hod.id LEFT JOIN employees e_h1 ON r.h1Id = e_h1.id LEFT JOIN employees e_h2 ON r.h2Id = e_h2.id ${whereClause} ORDER BY r.id DESC ${paginationSettings};`;
  };

  const getCountQuery = () => {
    let whereClause = getWhereClause();
    let outerCondition = "";

    // handle approveStatus
    const approveMatch = whereClause.match(/approveStatus\s+LIKE\s+'%(.+?)%'/i);
    if (approveMatch) {
      const key = approveMatch[1];
      outerCondition = `WHERE computedApproveStatus LIKE '%${key}%'`;
      whereClause = whereClause.replace(approveMatch[0], "1=1");
    }

    // handle disbursedStatus
    const disbursedMatch = whereClause.match(
      /disbursedStatus\s+LIKE\s+'%(.+?)%'/i,
    );
    if (disbursedMatch) {
      const key = disbursedMatch[1];
      const disbursedCondition = `computedDisbursedStatus LIKE '%${key}%'`;
      outerCondition = outerCondition
        ? `${outerCondition} AND ${disbursedCondition}`
        : `WHERE ${disbursedCondition}`;
      whereClause = whereClause.replace(disbursedMatch[0], "1=1");
    }

    return `SELECT COUNT(*) AS totalRows FROM (
  SELECT r.*,
    CASE WHEN r.l1Status=2 OR r.hodStatus=2 OR r.h1Status=2 OR r.h2Status=2 THEN 'Rejected' WHEN r.h2Status=1 THEN 'Approved' WHEN r.h1Status IN (1,2) THEN 'Pending at H2' WHEN r.hodStatus IN (1,2) THEN 'Pending at H1' WHEN r.l1Status IN (1,2) THEN 'Pending at HOD' ELSE 'Pending at L1' END AS computedApproveStatus,
    CASE WHEN r.disbursedStatus=1 THEN 'Disbursed' WHEN r.disbursedStatus=2 THEN 'Partially Disbursed' ELSE 'Pending' END AS computedDisbursedStatus
  FROM requirements r
  LEFT JOIN jobRegister jr ON r.jobId = jr.id
  LEFT JOIN employees e ON r.requesterId = e.id
  LEFT JOIN employees e_l1 ON r.l1Id = e_l1.id
  LEFT JOIN employees e_hod ON r.hodId = e_hod.id
  LEFT JOIN employees e_h1 ON r.h1Id = e_h1.id
  LEFT JOIN employees e_h2 ON r.h2Id = e_h2.id
  ${whereClause}
) AS sub ${outerCondition};`;
  };

  const fetchData = async () => {
    try {
      const [RequirementData, countResult] = await Promise.all([
        fetchQuery(getDataQuery()),
        fetchQuery(getCountQuery()),
      ]);

      setRequirementList(RequirementData);
      setTotalRows(countResult?.[0]?.totalRows || 0); // 👈 pagination total
    } catch (error) {
      console.error("Error fetching Requirement data:", error);
    }
  };

  const handleApprove = () => {
    setDialogProps({
      title: "Do you really want to Approve this?",
      showRemark: false,
      confirmText: "Approve",
      confirmColor: "success",
      onConfirm: async () => {
        const payload = {};

        if (permissions.l1) {
          payload.l1Status = 1;
          payload.l1Id = _employeeId;
        }
        if (permissions.hod && selectedRow?.projectHodId == _employeeId) {
          payload.hodStatus = 1;
          payload.hodId = _employeeId;
        }
        if (permissions.h1) {
          payload.h1Status = 1;
          payload.h1Id = _employeeId;
        }
        if (permissions.h2) {
          payload.h2Status = 1;
          payload.h2Id = _employeeId;
        }

        await axiosWithToken.patch(
          `${BASE_URL}requirements/${selectedRow.id}`,
          payload,
        );

        window.location.reload();
      },
    });

    setOpenConfirm(true);
  };

  const handleReject = () => {
    setDialogProps({
      title: "Enter Rejection Remark",
      showRemark: true,
      confirmText: "Reject",
      confirmColor: "error",
      onConfirm: async (finalRemark) => {
        const payload = { rejectionReason: finalRemark };

        if (permissions.l1) {
          payload.l1Status = 2;
        }
        if (permissions.hod && selectedRow?.projectHodId == _employeeId) {
          payload.hodStatus = 2;
        }
        if (permissions.h1) {
          payload.h1Status = 2;
        }
        if (permissions.h2) {
          payload.h2Status = 2;
        }

        await axiosWithToken.patch(
          `${BASE_URL}requirements/${selectedRow.id}`,
          payload,
        );

        window.location.reload();
      },
    });

    setOpenConfirm(true);
  };

  const handleSearch = () => {
    // if (!fromDate && !toDate && (!searchBy || !searchKey.trim())) {
    //   alert("Please select a search field and enter a search value.");
    //   return;
    // }
    fetchData();
    setSearched(true);
    // Save search state to sessionStorage
    sessionStorage.setItem("searchBy", searchBy);
    sessionStorage.setItem("searchKey", searchKey);
    sessionStorage.setItem("searched", "true");
    sessionStorage.setItem("currentPath", location.pathname);
    sessionStorage.setItem("ListPageCount", 0);
    setCurrentPage(0);
  };

  const clearSearch = () => {
    setSearched(false);
    setSearchBy("jobNumber");
    setSearchKey("");
    // Clear all employee list session storage
    sessionStorage.removeItem("ListPageCount");
    sessionStorage.removeItem("ListRowsPerPage");
    sessionStorage.removeItem("searchBy");
    sessionStorage.removeItem("searchKey");
    sessionStorage.removeItem("searched");
    setInputStates({})
    setCurrentPage(0);
  };

  const fetchEmployeesData = async () => {
    try {
      let whereConditions = "";

      // 👤 User-type restriction
      // if (_userType !== 1 && _userType !== 2 && _userType !== 8) {

      const hasFullAccess = permissions.l1 || permissions.h1 || permissions.h2;

      if (!hasFullAccess && !permissions.l2) {
        whereConditions = ` WHERE e.id = ${_employeeId}`;
      }


      // 🏢 Department condition
      if (inputStates?.departments?.length) {
        const departmentList = inputStates.departments
          .map((dept) => `'${dept}'`)
          .join(", ");
        whereConditions += whereConditions
          ? ` AND eod.department IN (${departmentList})`
          : ` WHERE eod.department IN (${departmentList})`;
      }

      // 🏬 Branch condition
      if (inputStates?.branch) {
        whereConditions += whereConditions
          ? ` AND eod.branchId = '${inputStates.branch}'`
          : ` WHERE eod.branchId = '${inputStates.branch}'`;
      }

      const Employees = await fetchQuery(`
          SELECT 
            e.id, 
            e.employeesCode, 
            e.name
          FROM employees e
          LEFT JOIN employeeOtherData eod 
            ON eod.employeeId = e.id
          ${whereConditions}
        `);

      setEmployeesData(Employees);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  const getJobData = async (employeeIds) => {
    try {
      const whereCondition =
        employeeIds && employeeIds.length > 0
          ? `WHERE r.requesterId IN (${employeeIds.join(",")})`
          : "";

      const result = await fetchQuery(
        `SELECT DISTINCT r.jobId, jr.jobNumber FROM requirements r LEFT JOIN jobRegister jr ON jr.id = r.jobId ${whereCondition}`,
      );
      setJobData(result);
    } catch (error) {
      console.error("Error fetching job data:", error);
    }
  };

  useEffect(() => {
    fetchEmployeesData();
  }, [inputStates.departments]);

  useEffect(() => {
    getJobData(inputStates.employeeIds);
  }, [inputStates.employeeIds]);

  useEffect(() => {
    fetchData();
  }, [currentPage, rowsPerPage]);

  useEffect(() => {
    if (searched == false) {
      fetchData();
    }
  }, [searched]);

  return (
    <>
      {(permissions.create || permissions.allAccess) && (
        <AddButton
          id="btn-add-outline"
          to="/editRequirement/0"
          label="Add Requirement"
          icon={<AddIcon fontSize="small" />}
        />
      )}




      <div className="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-4 mt-4">
        {/* {[1, 2, 8].includes(_userType) && ( */}

        <Autocomplete
          multiple
          limitTags={1}
          size="small"
          disableCloseOnSelect
          options={["Select All", ...departmentOptions]}
          getOptionLabel={(option) =>
            typeof option === "string" ? option : option.name
          }
          isOptionEqualToValue={(option, value) =>
            typeof option === "string" || typeof value === "string"
              ? option === value
              : option.id === value.id
          }
          value={departmentOptions.filter((dept) =>
            (inputStates.departments || []).includes(dept.name),
          )}
          onChange={(_, selected) => {
            const isAll = selected.some((s) => s === "Select All");
            const selectedNames = isAll
              ? departmentOptions.map((d) => d.name)
              : selected
                .filter((s) => s !== "Select All")
                .map((s) => (typeof s === "string" ? s : s.name));
            updateInputObject("departments", selectedNames);
          }}
          renderOption={(props, option, { selected }) => (
            <li {...props}>
              <Checkbox
                sx={{ mr: 1 }}
                checked={
                  option === "Select All"
                    ? (inputStates.departments?.length || 0) ===
                    departmentOptions.length
                    : selected
                }
              />
              {typeof option === "string" ? option : option.name}
            </li>
          )}
          renderInput={(params) => (
            <TextField {...params} placeholder="Select department" />
          )}
        />

        <Autocomplete
          multiple
          limitTags={1}
          size="small"
          disableCloseOnSelect
          // fullWidth
          options={[{ id: "ALL", name: "Select All" }, ...employeesData]}
          isOptionEqualToValue={(opt, val) => opt.id === val.id}
          getOptionLabel={(option) =>
            option.id === "ALL"
              ? "Select All"
              : `${option.employeesCode ? option.employeesCode + " - " : ""}${option.name}`
          }
          value={employeesData.filter((emp) =>
            inputStates.employeeIds?.includes(emp.id),
          )}
          onChange={(_, selected) => {
            updateInputObject(
              "employeeIds",
              selected.some((opt) => opt.id === "ALL")
                ? employeesData.map((e) => e.id)
                : selected.map((e) => e.id),
            );
          }}
          renderOption={(props, option, { selected }) => (
            <li {...props}>
              <Checkbox
                sx={{ mr: 1 }}
                checked={
                  option.id === "ALL"
                    ? inputStates.employeeIds?.length === employeesData.length
                    : selected
                }
              />
              {option.id === "ALL"
                ? "Select All"
                : `${option.employeesCode ? option.employeesCode + " - " : ""}${option.name}`}
            </li>
          )}
          renderInput={(params) => <TextField {...params} label="Requester" />}
        />
        {/* )} */}

        <Autocomplete
          multiple
          limitTags={1}
          size="small"
          disableCloseOnSelect
          options={[{ jobId: "ALL", jobNumber: "Select All" }, ...jobData]}
          isOptionEqualToValue={(opt, val) => opt.jobId === val.jobId}
          getOptionLabel={(option) =>
            option.jobId === "ALL" ? "Select All" : `${option.jobNumber}`
          }
          value={jobData?.filter((job) =>
            inputStates.selectedJobIds?.includes(job.jobId),
          )}
          onChange={(_, selected) => {
            updateInputObject(
              "selectedJobIds",
              selected.some((opt) => opt.jobId === "ALL")
                ? jobData.map((j) => j.jobId)
                : selected.map((j) => j.jobId),
            );
          }}
          renderOption={(props, option, { selected }) => (
            <li {...props}>
              <Checkbox
                sx={{ mr: 1 }}
                checked={
                  option.jobId === "ALL"
                    ? inputStates.selectedJobIds?.length === jobData.length
                    : selected
                }
              />
              {option.jobId === "ALL" ? "Select All" : `${option.jobNumber}`}
            </li>
          )}
          renderInput={(params) => <TextField {...params} label="Select Job" />}
        />

        <Autocomplete
          multiple
          limitTags={1}
          size="small"
          disableCloseOnSelect
          options={["Select All", ...requirementTypeOptions]}
          getOptionLabel={(option) =>
            typeof option === "string" ? option : option.name
          }
          isOptionEqualToValue={(option, value) =>
            typeof option === "string" || typeof value === "string"
              ? option === value
              : option.id === value.id
          }
          value={requirementTypeOptions.filter((type) =>
            (inputStates.requirementTypes || []).includes(type.name),
          )}
          onChange={(_, selected) => {
            const isAll = selected.some((s) => s === "Select All");
            const selectedNames = isAll
              ? requirementTypeOptions.map((t) => t.name)
              : selected
                .filter((s) => s !== "Select All")
                .map((s) => (typeof s === "string" ? s : s.name));
            updateInputObject("requirementTypes", selectedNames);
          }}
          renderOption={(props, option, { selected }) => (
            <li {...props}>
              <Checkbox
                sx={{ mr: 1 }}
                checked={
                  option === "Select All"
                    ? (inputStates.requirementTypes?.length || 0) ===
                    requirementTypeOptions.length
                    : selected
                }
              />
              {typeof option === "string" ? option : option.name}
            </li>
          )}
          renderInput={(params) => (
            <TextField {...params} placeholder="Select requirement type" />
          )}
        />

        {/* From Date */}
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            label="From Date"
            value={inputStates.fromDate || null}
            onChange={(val) => updateInputObject("fromDate", val)}
            slotProps={{ textField: { size: "small", fullWidth: true } }}
          />
        </LocalizationProvider>

        {/* To Date */}
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            label="To Date"
            value={inputStates.toDate || null}
            onChange={(val) => updateInputObject("toDate", val)}
            slotProps={{ textField: { size: "small", fullWidth: true } }}
          />
        </LocalizationProvider>



        <Autocomplete
          multiple
          limitTags={1}
          size="small"
          disableCloseOnSelect
          options={[{ label: "Select All", value: "ALL" }, ...STATUS_OPTIONS]}
          getOptionLabel={(option) => option.label}
          isOptionEqualToValue={(option, value) => option.value === value.value}
          value={STATUS_OPTIONS.filter((opt) =>
            inputStates.approveStatus?.some((s) => s.value === opt.value),
          )}
          onChange={(_, selected) => {
            const isAll = selected.some((opt) => opt.value === "ALL");
            updateInputObject(
              "approveStatus",
              isAll
                ? [...STATUS_OPTIONS]
                : selected.filter((s) => s.value !== "ALL"),
            );
            setSearched(false);
          }}
          renderOption={(props, option, { selected }) => (
            <li {...props}>
              <Checkbox
                sx={{ mr: 1 }}
                checked={
                  option.value === "ALL"
                    ? inputStates.approveStatus?.length ===
                    STATUS_OPTIONS.length
                    : selected
                }
              />
              {option.label}
            </li>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Approve Status"
              placeholder="Select status"
            />
          )}
        />

        <SearchToggleButton
          searched={searched}
          onSearch={handleSearch}
          onClear={clearSearch}
        />
      </div>

      <ListView
        headers={headers}
        data={disciplineList}
        actions={{
          edit: handleEdit,
          modal: handleModal,
          print: handlePrint,
          delete: handleDelete,
          // disbursed: handleDisbursed,
          // partiallyDisbursed: handlePartiallyDisbursed,
        }}
        showCheckbox={true}
        deleteTableName={"requirements"}
        moduleId={props.moduleId}
        currentPage={currentPage}
        rowsPerPage={rowsPerPage}
        totalRows={totalRows}
        onPaginationChange={handlePaginationChange}
        reqList={true}
      />

      <div>
        {/* Example button to trigger modal */}

        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">
          <DialogTitle
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            Requirement Status{" "}
            {selectedRow
              ? `of ${selectedRow?.jobNumber} Job requested by ${selectedRow?.requesterName}`
              : ""}
            <IconButton onClick={handleClose} sx={{ color: "red" }}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>

          <DialogContent>
            <ListView
              headers={modalHeaders}
              data={selectedRow ? [selectedRow] : []}
              actions={{
                approve: handleApprove,
                reject: handleReject,
                // redFlag:handleRedFlag,
              }}
              // disabled={selectedRow?.leaveStatus === "Rejected"}
              headerEmployee={true}
              moduleId={props.moduleId}
              headerEmployeeKeys={[
                "l1Name",
                "hodName",
                "h1Name",
                "h2Name",
                "",
                "",
              ]}
              _employeeId={_employeeId}
              requirement={true}
            />
          </DialogContent>
        </Dialog>
        <AppConfirmBox
          open={openConfirm}
          onClose={() => setOpenConfirm(false)}
          remark={remark}
          setRemark={setRemark}
          amount={amount}
          setAmount={setAmount}
          {...dialogProps}
        />
      </div>
    </>
  );
};

export default RequirementList;
